import axios from "axios";
import { FormType } from "../models/FormType";

const baseUrl = "/AutoConnectSSO/api/InscriptionFlow/InscriptionFlows";
function getFormTypeUrl(flowId: number, formTypeId?: number) {
  const urlEnd = formTypeId?.toString() ?? "";
  return `/${flowId}/FormType/${urlEnd}`;
}

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

async function getFormTypes(flowId: number) {
  const url = getFormTypeUrl(flowId);
  return instance.get<FormType>(url);
}

async function getFormType(flowId: number, formTypeId: number) {
  const url = getFormTypeUrl(flowId, formTypeId);
  return instance.get<FormType>(url);
}

export const AutonomousFormTypeService = {
  getFormTypes,
  getFormType
};
